<template>
  <TheG01Content
    :categories="categories"
    class="p-the-g01-content-point"
    :is-category="false"
  >
    <div class="p-the-g01-content-point__list">
      <template v-for="(category, key) in categories">
        <G01ItemListGroup
          v-if="category.sku_set.length > 0"
          :key="key"
          :category-id="category.category_id"
          :category-label="category.category_name"
          :items="category.sku_set"
          :is-category="false"
          :is-first="category.is_first"
          class="p-the-g01-content-point__list__item"
        />
      </template>
    </div>
  </TheG01Content>
</template>

<script lang="ts">
import TheG01Content from "@/general/components/pages/parts/Ranking/TheG01Content.vue";
import G01ItemListGroup from "@/general/components/pages/parts/Ranking/G01ItemListGroup.vue";
import { Options, Vue } from 'vue-class-component';
import items from "@/general/store/modules/items";
import commons from "@/common/store/modules/commons";
import { rankingByPoints } from "@/general/store/api";

@Options({
  components: {
    TheG01Content,
    G01ItemListGroup
  }
})
export default class TheG01ContentPoint extends Vue {
  rankingPoints: any = [];

  async created() {
    this.rankingPoints = await rankingByPoints();
  }

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }
  get categories() {
    return this.rankingPoints.map((item: any, index: number) => {
      if (item.lower_limit == null) {
        item["category_name"] = "~" + item.upper_limit + " " + this.unit;
      } else {
        if (item.upper_limit == null) {
          item["category_name"] = item.lower_limit + " " + this.unit + " ~";
        } else {
          item["category_name"] =
            item.lower_limit + "-" + item.upper_limit + " " + this.unit;
        }
      }

      item["category_id"] = "ex-" + index;
      return item;
    });
  }
}
</script>

<style lang="scss" scoped>
.p-the-g01-content-point {
  &__list {
    &__item {
      margin-top: rem(24);

      @include large-sp {
        &:first-of-type {
          border-top: px(1) solid $common-gray-border;
        }
      }
    }
  }
}
</style>
